const tickerList = [
  '古装剧《月满西楼》全集上线 · 首日热度破平台纪录',
  '《声浪计划》导师后台花絮流出 · 网友喊话放完整版',
  '新生代歌手《春信》三首主打齐冲实时榜前十',
  '顶流艺人某运动品牌代言到期 · 下一任成悬念',
];

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-gradient-to-b from-primary-100 via-background-50 to-background-50">
      {/* 装饰元素 */}
      <div className="pointer-events-none absolute inset-0" aria-hidden="true">
        <span className="absolute left-[6%] top-16 hidden text-6xl text-primary-200 md:block animate-float">🍉</span>
        <span className="absolute right-[8%] top-24 hidden text-5xl text-accent-300 md:block animate-float" style={{ animationDelay: '.6s' }}>🍃</span>
        <span className="absolute left-[12%] bottom-24 hidden text-4xl text-secondary-300 lg:block animate-float" style={{ animationDelay: '1.1s' }}>✨</span>
        <span className="absolute right-[16%] bottom-16 hidden text-5xl text-primary-200 md:block animate-float" style={{ animationDelay: '1.5s' }}>📢</span>
      </div>

      <div className="relative mx-auto flex w-full max-w-6xl flex-col items-center px-4 pt-14 pb-8 text-center md:pt-20 md:pb-10">
        <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-background-50/80 px-4 py-1.5 text-xs font-medium text-primary-700 md:text-sm">
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full rounded-full bg-primary-500 animate-pulse-dot" />
          </span>
          全网热瓜实时汇总 · 每日更新
        </span>

        <h1 className="mt-6 font-heading text-4xl leading-tight text-foreground-950 md:text-6xl">
          今日新瓜速递<span className="text-primary-500">.</span>
        </h1>
        <p className="mt-3 text-lg font-medium text-foreground-700 md:text-2xl">
          每天叫醒我的不是闹钟，是<span className="mx-1 rounded-md bg-secondary-200 px-1.5 text-secondary-900">新鲜的瓜</span>
        </p>

        <p className="mt-5 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
          影视、综艺、音乐、商业与圈内趣闻一站式吃瓜。最新爆料合集、热门大瓜汇总实时更新，
          第一时间掌握新瓜动态，不错过任何精彩瞬间。
        </p>

        <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
          <a
            href="#trending"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3.5 text-sm font-semibold text-background-50 transition hover:bg-primary-600"
          >
            <i className="ri-fire-line text-lg" aria-hidden="true" />
            看今日热榜
          </a>
          <a
            href="#feed"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-7 py-3.5 text-sm font-semibold text-foreground-800 transition hover:border-primary-300 hover:bg-primary-50"
          >
            <i className="ri-flashlight-line text-lg" aria-hidden="true" />
            刷最新爆料
          </a>
        </div>
      </div>

      {/* 跑马灯速递条 */}
      <div className="relative border-t border-background-200 bg-accent-500 py-2.5">
        <div className="flex items-center overflow-hidden" aria-hidden="true">
          <div className="flex shrink-0 items-center gap-10 whitespace-nowrap animate-ticker">
            {[...tickerList, ...tickerList].map((t, i) => (
              <span key={i} className="flex items-center gap-2 text-sm font-medium text-accent-950">
                <i className="ri-broadcast-line" aria-hidden="true" />
                {t}
              </span>
            ))}
          </div>
          <div className="flex shrink-0 items-center gap-10 whitespace-nowrap animate-ticker">
            {[...tickerList, ...tickerList].map((t, i) => (
              <span key={i} className="flex items-center gap-2 text-sm font-medium text-accent-950">
                <i className="ri-broadcast-line" aria-hidden="true" />
                {t}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}